import classNames from 'classnames';

import { Tag } from '@spotify-internal/encore-web';

import { isDemoData } from '../../utils/format-label';

import styles from './DemoTag.module.css';

export type DemoTagProps = {
  labels?: Array<{ key: string; value?: string | null }>;
  variant?: 'default' | 'pageTitle';
};

export const DemoTag = ({ labels, variant }: DemoTagProps) =>
  isDemoData(labels) ? (
    <Tag
      className={classNames(styles.tag, {
        [styles.pageTitle]: variant === 'pageTitle',
      })}
    >
      Demo data
    </Tag>
  ) : null;
